import { render, staticRenderFns } from "./CBProposalKeysAndSpecialProtectionMeans.vue?vue&type=template&id=19b4eab9"
import script from "./CBProposalKeysAndSpecialProtectionMeans.vue?vue&type=script&lang=js"
export * from "./CBProposalKeysAndSpecialProtectionMeans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports